import { CreateTagDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

// TODO: resource registry should expose this as a input type
interface CreateTagInput {
  companyId: string
  name: string
}

export const useCreateTag = () => {
  const [createTag, { loading }] = useMutation(CreateTagDocument, {
    awaitRefetchQueries: true,
    extractorFn: (data) => data.atsMutations.createAtsTag,
  })

  return {
    loading,
    create(variables: CreateTagInput) {
      return createTag({
        variables,
      })
    },
  }
}
